import { render, staticRenderFns } from "./DepartmentSwitcher.vue?vue&type=template&id=5bea13a7"
import script from "./DepartmentSwitcher.vue?vue&type=script&lang=js"
export * from "./DepartmentSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports